export default {
  // 运价库
  rateWarehouse: {
    title: '运价库',

    // 标签页
    tabs: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      preport: '港前运价',
      lastmile: '尾程运价'
    },
    tabPlaceholder: '点击切换到{title}加载页面',

    segmentRoute: {
      serviceType: '服务类型',
      transportMode: '运输方式',
      addressType: '地址类型',
      trailer: '拖车',
      barge: '驳船',
      rail: '铁路',
      seaPort: '海港',
      railwayStation: '铁路站',
      airport: '机场',
      loadingPlace: '装货地',
      destinationPlace: '目的地',
      shippingCompany: '船公司',
      railwayCompany: '铁路公司',
      bargeVessel: '驳船船名',
      bargeVoyage: '驳船航次',
      trainNo: '车次',
      transportDays: '航程（天）',
      bargeDepartureTime: '驳船开航时间',
      bargeArrivalTime: '驳船到港时间',
      trainDepartureTime: '预计发车时间',
      loadingRailwayStation: '装货铁路站',
      destinationRailwayStation: '目的铁路站',
      validation: {
        transportMode: '请选择运输方式',
        addressType: '请选择地址类型'
      }
    },
    // 公共（整箱/拼箱共用）
    common: {
      // 列标题
      columns: {
        priceNo: '运价编码',
        source: '运价来源',
        status: '运价状态',
        cargoType: '货物类型',
        supplierId: '供应商',
        relatedNo: '关联单号',
        carrierId: '船公司',
        originCountry: '起运国家',
        destinationCountry: '目的国家',
        contractNo: '约号',
        cargoDesc: '货物描述',
        transportMode: '运输方式',
        routeType: '航线类型',
        containerOwnership: '箱属',
        pol: '起运港',
        polTerminal: '起运港码头',
        pod: '卸货港',
        podTerminal: '卸货港码头',
        pdl: '目的地',
        por: '收货地',
        portOfDischarge: '目的地',
        placeOfDelivery: '收货地',
        directFlag: '直达/中转',
        transitPort: '中转港',
        pot1: '中转港1',
        pot2: '中转港2',
        pot3: '中转港3',
        vessel: '船名',
        voyage: '航次',
        laneCode: '航线代码',
        sailingDays: '开航班期',
        cutoffDays: '截关班期',
        etd: 'ETD',
        eta: 'ETA',
        beginDate: '生效日期',
        endDate: '失效日期',
        freeDetentionDays: '目的港免柜期',
        freeDemurrageDays: '目的港免堆期',
        unpackDelivery: '拆柜派送',
        weightLimit: '限重',
        receivingInstructions: '特殊说明',
        remarks: '备注',
        operations: '操作'
      },

      // 操作按钮
      actions: {
        create: '新建',
        import: '导入',
        search: '查询',
        view: '查看',
        edit: '编辑',
        copy: '复制',
        more: '更多',
        enable: '启用',
        disable: '禁用',
        delete: '删除',
        back: '返回',
        saveDraft: '保存草稿',
        save: '保存',
        add: '添加',
        batchOperations: '批量操作',
        batchEnable: '批量启用',
        batchDisable: '批量禁用',
        batchDelete: '批量删除'
      },

      importDialog: {
        title: '{type}导入',
        downloadTemplate: '下载导入模板',
        reminderTitle: '功能提示',
        reminderLine1: '上传后将生成后台导入任务，可在任务管理查看处理结果。',
        reminderLine2: '系统会按模板字段校验并写入运价库。',
        fileLimit: '仅支持 .xls / .xlsx，文件大小不超过 10MB。',
        selectFile: '点击或拖拽 Excel 文件到此处',
        submit: '上传并导入',
        uploading: '正在提交导入任务...',
        invalidFileType: '仅支持 xls、xlsx 格式文件',
        fileTooLarge: '文件大小不能超过 10MB',
        selectFileFirst: '请选择导入文件',
        submitSuccess: '导入任务已提交，请到任务管理查看处理结果',
        downloadFailed: '模板下载失败',
        uploadFailed: '导入任务提交失败，请稍后重试'
      },

      // 消息提示
      messages: {
        loadFailed: '加载数据失败',
        enableSuccess: '启用成功',
        disableSuccess: '禁用成功',
        operationFailed: '操作失败',
        batchEnableSuccess: '批量启用成功',
        batchDisableSuccess: '批量禁用成功',
        batchDeleteSuccess: '批量删除成功',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        saveDraftSuccess: '草稿已保存',
        saveSuccess: '保存成功',
        updateSuccess: '更新成功',
        saveFailed: '保存失败',
        saveDraftFailed: '保存草稿失败',
        loadDetailFailed: '加载运价详情失败',
        copyTip: '已复制原运价信息，新运价编码将在保存后生成',
        missingId: '缺少运价ID，无法加载详情',
        notFound: '未查询到运价详情',
        missingIdSaveDraft: '缺少运价ID，无法保存草稿',
        missingIdSave: '缺少运价ID，无法保存',
        fillRequired: '请完善必填项',
        feeDataCacheFailed: '加载费用数据缓存失败:',
        duplicateFeeItem: '该费用项已存在附加费行，不能重复添加',
        duplicateContainerType: '该箱型已存在海运费行，不能重复添加',
        minOneContainerColumn: '至少保留一个箱型列',
        selectAtLeastOneColumn: '请至少选择一个箱型列',
        allInPriceTip: '该运价由 All In 价格报价导入，询价计算不再叠加附加费。'
      },

      // 确认弹窗
      confirm: {
        deleteTitle: '删除确认',
        deleteContent: '确认删除此条运价？',
        batchEnableTitle: '批量启用',
        batchEnableContent: '确认启用选中的 {count} 条运价？',
        batchDisableTitle: '批量禁用',
        batchDisableContent: '确认禁用选中的 {count} 条运价？',
        batchDeleteTitle: '批量删除',
        batchDeleteContent: '确认删除选中的 {count} 条运价？删除后不可恢复。'
      },

      // 区域标题
      sections: {
        basicInfo: '基础信息',
        timelinessInfo: '时效信息',
        scheduleInfo: '船期信息',
        feeInfo: '费用信息',
        remarkInfo: '备注信息'
      },

      // 表单字段（列标题之外的额外字段）
      fields: {
        validPeriod: '价格有效期',
        tradeTermsId: '贸易条款',
        onePrice: 'All In 价格',
        combinationType: '组合方式',
        specifiedMatchCodes: '指定匹配运价',
        specifiedDestRegions: '指定目的区域',
        specifiedDestRegionLogic: '目的区域逻辑',
        allInPriceIncludedItems: 'All In 价格包含项目',
        allInPriceRemarks: 'All In 价格备注',
        potentialFeeType: '潜在费用类型',
        timelinessAchievementRate: '时效达成率(%)',
        carrierPromiseDays: '承运商承诺全程时效',
        pickupLeadTime: '前置提货时长',
        portToPortDays: '港到港时效',
        clearanceDeliveryDays: '清派时效',
        freeDetentionDaysLabel: '目的港免柜期(天)',
        freeDemurrageDaysLabel: '目的港免堆期(天)',
        unpackDeliveryLabel: '拆柜派送',
        weightLimitLabel: '限重(kg)'
      },

      // 费用默认值
      feeDefaults: {
        baseFee: '基础费用'
      },

      // 占位符
      placeholders: {
        autoGenerate: '保存后由系统自动生成',
        select: '请选择',
        input: '请输入',
        relatedNo: '询价/招标单号',
        cargoDesc: '货物描述',
        searchPriceNo: '输入运价编码后回车，留空匹配所有',
        destinationRegions: '请选择航线（可多选，留空不限制）',
        destinationRegionHint: '填写后仅匹配干线目的港所在航线分类满足该条件的运价',
        contractNo: '关联合约号',
        beginDate: '开始日期',
        endDate: '结束日期',
        vessel: '船名',
        voyage: '航次',
        laneCode: '航线代码',
        selectDate: '请选择日期',
        potentialFeeType: '请选择潜在费用类型',
        freeDetentionDays: '请输入免柜期',
        freeDemurrageDays: '请输入免堆期',
        weightLimit: '请输入限重',
        receivingInstructions: '请输入特殊说明',
        remarks: '请输入备注',
        all: '全部',
        selectDate2: '选择日期'
      },

      options: {
        freeCombination: '自由组合',
        preciseCombination: '精准组合',
        include: '包含',
        exclude: '不包含'
      },

      // 表单校验
      validation: {
        status: '请选择运价状态',
        supplierId: '请选择供应商',
        cargoType: '请选择货物类型',
        validPeriod: '请选择价格有效期',
        transportMode: '请选择运输方式',
        routeType: '请选择航线类型',
        carrierId: '请选择船公司',
        pol: '请选择起运港',
        pod: '请选择卸货港',
        sailingDays: '请选择开航班期',
        cutoffDays: '请选择截关班期',
        directFlag: '请选择直达/中转',
        surchargeSelectPotentialFeeType: '附加费第{index}行请选择合法的潜在费用类型',
        endDateBeforeBeginDate: '有效期截止日期必须大于等于生效日期',
        fillRequired: '请完善必填项',
        polOrPlaceOfDelivery: '收货地和起运港至少填写一个',
        podOrPortOfDischarge: '卸货港和目的地至少填写一个'
      },

      // 单位
      units: {
        day: '天'
      }
    },

    // 枚举国际化
    enums: {
      source: {
        inquiry: '询价入库',
        bidding: '招标入库',
        manual: '手工录入',
        system: '系统生成'
      },
      status: {
        normal: '正常',
        expired: '失效',
        disabled: '禁用'
      },
      routeType: {
        economy: '经济航线',
        express: '快速航线'
      },
      directFlag: {
        direct: '直达',
        transit: '中转',
        directTransit: '直达/中转'
      },
      feeType: {
        transportFee: '运输费',
        airFreight: '空运费附加费',
        oceanFreight: '海运附加费',
        portFee: '起运港费用',
        destinationPortFee: '目的港费用',
        otherFee: '其他费用',
        potentialFee: '潜在费用',
        prePortSurcharge: '港前附加费',
        lastMileSurcharge: '尾程附加费'
      },
      potentialFeeType: {
        seaSurcharge: '海运附加费',
        airSurcharge: '空运附加费',
        seaOrigin: '起运港费用',
        seaDestination: '目的港费用',
        airOrigin: '起飞地费用',
        airDestination: '目的地费用'
      },
      yesNo: {
        yes: '是',
        no: '否'
      },
      weekday: {
        mon: '周一',
        tue: '周二',
        wed: '周三',
        thu: '周四',
        fri: '周五',
        sat: '周六',
        sun: '周日'
      },
      cargoType: {
        general: '普货',
        dangerous: '危险品',
        reefer: '冷冻品',
        special: '特种箱',
        steelCoil: '卷钢',
        liquid: '液体',
        chemical: '化工品',
        textile: '纺织品',
        reeferDangerous: '冷危品'
      }
    },

    // 整箱
    fcl: {
      createTitle: '新建整箱运价',
      editTitle: '编辑整箱运价',
      viewTitle: '整箱运价详情',
      copyTitle: '复制整箱运价',

      columns: {
        pod: '目的港',
        podTerminal: '目的港码头',
        chargingItems: '费用信息'
      },

      feeTable: {
        seaFreightTitle: '海运费',
        containerType: '箱型',
        billingUnit: '计费单位',
        currency: '币种',
        oceanFreight: '海运费',
        operations: '操作'
      },

      surcharge: {
        title: '附加费明细',
        addContainerColumn: '添加箱型列',
        feeName: '费用名称',
        feeType: '费用类型',
        includedInBasePrice: '已含在海运费',
        unit: '单位',
        currency: '币种',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        remarks: '费用备注',
        selectContainerTitle: '选择附加费箱型列',
        removeColumnAriaLabel: '移除{label}列',
        minOneContainerColumn: '附加费明细至少保留一个箱型列',
        selectAtLeastOneColumn: '请至少选择一个箱型列'
      },

      validation: {
        pod: '请选择目的港',
        seaFeeSelectContainer: '海运费第{index}行请选择箱型',
        seaFeeDuplicateContainer: '海运费第{index}行箱型重复，请检查',
        seaFeeSelectBillingUnit: '海运费第{index}行：请选择计费单位',
        seaFeeDuplicateBillingUnit: '海运费第{index}行：计费单位重复，请检查',
        seaFeeSelectCurrency: '海运费第{index}行请选择币种',
        seaFeeInputAmount: '海运费第{index}行请输入海运费',
        surchargeSelectFee: '附加费第{index}行请选择费用名称',
        surchargeDuplicateFee: '附加费第{index}行费用名称重复，请检查',
        surchargeSelectCurrency: '附加费第{index}行请选择币种',
        surchargeSelectUnit: '附加费第{index}行请选择单位',
        surchargeInputUnitRate: '附加费第{index}行请输入单价',
        surchargeInputContainerFee: '附加费第{index}行请至少录入一个箱型费用'
      }
    },

    // 拼箱
    lcl: {
      createTitle: '新建拼箱运价',
      editTitle: '编辑拼箱运价',
      viewTitle: '拼箱运价详情',
      copyTitle: '复制拼箱运价',

      columns: {
        pod: '目的港',
        podTerminal: '目的港码头',
        tradeTermsId: '贸易条款'
      },

      feeSection: {
        title: '费用明细',
        feeName: '费用名称',
        currency: '币种',
        billingUnit: '单位',
        unitRate: '单价',
        minConsume: '最低消费',
        defaultFeeName: '基础海运费',
        unitRatePlaceholder: '海运费单价',
        minConsumePlaceholder: '最低收费金额'
      },

      surcharge: {
        title: '附加费明细',
        feeName: '费用名称',
        feeType: '费用类型',
        currency: '币种',
        unit: '单位',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        remarks: '备注',
        operations: '操作'
      },

      validation: {
        pod: '请选择目的港',
        currency: '请选择费用明细币种',
        unitRate: '请输入费用明细单价',
        surchargeDuplicateFee: '附加费第{index}行费用名称重复，请检查',
        surchargeSelectFeeType: '附加费第{index}行请选择费用类型',
        surchargeSelectCurrency: '附加费第{index}行请选择币种',
        surchargeSelectUnit: '附加费第{index}行请选择单位',
        surchargeInputUnitRate: '附加费第{index}行请输入单价'
      }
    },

    // 公共脚手架（空运/港前/尾程共用）
    scaffold: {
      sourceOptions: {
        inquiry: '询价入库',
        template: '模板入库',
        manual: '手工录入'
      },
      statusOptions: {
        enabled: '有效',
        disabled: '失效'
      },
      labels: {
        rateNo: '运价编码',
        source: '运价来源',
        status: '运价状态',
        validPeriod: '有效期'
      },
      defaultOriginLabel: '起运港',
      defaultDestinationLabel: '目的港'
    },

    // 空运
    air: {
      createTitle: '新增空运运价',
      editTitle: '编辑空运运价',
      viewTitle: '空运运价详情',
      copyTitle: '复制空运运价',

      columns: {
        rateNo: '运价编码',
        source: '运价来源',
        airline: '航空公司',
        departureAirport: '起飞机场',
        destinationAirport: '目的机场',
        pickupAddress: '提货地',
        destination: '最终目的地',
        routeGrade: '航线等级',
        packageType: '包装类型',
        directFlag: '直航/中转',
        flightNo: '航班号',
        aircraftType: '机型',
        flightSchedule: '航班班期',
        estimatedDepartureTime: '预计起飞时间',
        estimatedArrivalTime: '预计到达时间',
        voyageTime: '航程',
        voyageTimeUnit: '航程单位',
        chargingItems: '运费明细',
        freeDetentionDays: '机场免存期',
        freeDemurrageDays: 'CFS免存期',
        specialInstructions: '特殊说明',
        capacityCbm: '舱位体积上限(CBM)',
        transitAirports: '中转机场',
        baseRemarks: '基础备注'
      },
      originLabel: '起飞机场',
      destinationLabel: '目的机场',
      enums: {
        routeGrade: {
          normal: '普通',
          express: '快速'
        },
        directFlag: {
          direct: '直航',
          transit: '中转',
          both: '直航/中转'
        },
        packageType: {
          bulk: '散货',
          pallet: '托盘'
        },
        cargoType: {
          general: '普货',
          magnetic: '带磁',
          battery: '带电',
          magneticBattery: '带磁带电'
        },
        voyageTimeUnit: {
          hour: '小时',
          day: '天',
          minute: '分钟'
        }
      },
      durationUnits: {
        day: '天',
        hour: '时',
        minute: '分',
        compactDay: 'D',
        compactHour: 'H',
        compactMinute: 'M'
      },
      placeholders: {
        flightNo: '请输入航班号',
        aircraftType: '请输入机型',
        voyageTime: '请输入航程',
        capacityCbm: '请输入舱位体积',
        transitAirports: '请输入中转机场',
        specialInstructions: '请输入特殊说明',
        baseRemarks: '请输入备注'
      },
      sections: {
        flightInfo: '航班信息',
        feeDetail: '费用明细',
        surchargeDetail: '附加费明细',
        remarkInfo: '备注信息'
      },
      feeSection: {
        title: '运费',
        addRow: '添加运费行',
        densityDegree: '密度等级',
        currency: '币种',
        minConsume: '最低消费(M)',
        normalValency: '普通价格(N)',
        price45kg: '45KG+',
        price100kg: '100KG+',
        price300kg: '300KG+',
        price500kg: '500KG+',
        price700kg: '700KG+',
        price1000kg: '1000KG+',
        price2000kg: '2000KG+'
      },
      validation: {
        carrierId: '请选择航空公司',
        polId: '请选择起飞机场',
        podId: '请选择目的机场',
        packageType: '请选择包装类型',
        directFlag: '请选择直航/中转',
        transitAirports: '请选择中转机场',
        surchargeSelectFee: '附加费第{index}行请选择费用名称',
        surchargeDuplicateFee: '附加费第{index}行费用名称重复，请检查',
        surchargeSelectFeeType: '附加费第{index}行请选择费用类型',
        surchargeSelectUnit: '附加费第{index}行请选择单位',
        surchargeSelectCurrency: '附加费第{index}行请选择币种',
        surchargeInputUnitRate: '附加费第{index}行请输入单价'
      }
    },

    // 港前
    preport: {
      createTitle: '新建港前运价',
      editTitle: '编辑港前运价',
      viewTitle: '港前运价详情',
      copyTitle: '复制港前运价',

      columns: {
        priceNo: '运价编码',
        rateNo: '运价编码',
        source: '运价来源',
        supplier: '供应商',
        rateType: '运价类型',
        pol: '起运港',
        polAirport: '起运机场',
        wharf: '码头',
        originTerminal: '起运码头',
        originRailwayStation: '起运站',
        airportTerminal: '机场货站',
        loadingAddressType: '地址类型',
        warehouseCode: '仓库',
        origin: '起运地',
        destination: '目的地',
        province: '省',
        city: '市',
        district: '区/县',
        street: '镇/街道',
        community: '社区',
        regionItems: '起运区域',
        currency: '币种',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        createdBy: '创建人',
        dateCreated: '创建时间',
        modifiedBy: '修改人',
        dateModified: '修改时间'
      },

      enums: {
        addressType: {
          thirdParty: '第三方地址',
          warehouse: '仓库'
        },
        cargoType: {
          general: '普货',
          magnetic: '带磁',
          battery: '带电',
          magneticBattery: '带磁带电'
        },
        rateType: {
          directDrag: '直拖',
          branchLine: '支线',
          seaRail: '海铁'
        }
      },

      sections: {
        basicInfo: '基础信息',
        loadingInfo: '装货地信息',
        portInfo: '起运港信息',
        regionInfo: '第三方地址',
        feeInfo: '费用明细',
        surchargeDetail: '附加费明细'
      },

      region: {
        title: '地区列表',
        addRegion: '添加地区',
        regionIndex: '地区 {index}',
        country: '国家',
        selectRegionInfo: '请选择地区信息',
        administrativeDivision: '行政区划',
        detailedLocation: '详细位置',
        detailedAddress: '详细地址',
        selectProvince: '请选择省',
        selectCity: '请选择市',
        selectDistrict: '请选择区/县',
        selectStreet: '请选择镇/街道',
        selectCommunity: '请选择社区',
        enterDetailedAddress: '请输入门牌/楼层/具体位置等',
        atLeastOneRegion: '至少保留一条地区信息',
        defaultCountryName: '中国'
      },

      placeholders: {
        rateType: '请选择运价类型',
        pol: '请选择起运港',
        polAirport: '请选择起运机场',
        wharf: '请选择码头',
        airportTerminal: '请输入机场货站',
        warehouseCode: '请选择仓库（可多选）'
      },

      validation: {
        supplierId: '请选择供应商',
        cargoType: '请选择货物类型',
        rateType: '请选择运价类型',
        loadingAddressType: '请选择地址类型',
        thirdPartyAddress: '请填写第三方详细地址',
        warehouseCode: '请至少选择一个仓库',
        validPeriod: '请选择价格有效期',
        polOrPolAirport: '起运港和起运机场至少填写一个',
        originSeaport: '请选择起运港',
        originRailwayStation: '请选择起运站',
        originAirport: '请选择起运机场',
        specifiedMatchRequired: '海港非箱型拼箱费用必须填写指定匹配运价'
      },

      feeSection: {
        title: '运费',
        addRow: '添加费用行',
        feeName: '费用名称',
        nameCn: '费用名称(中文)',
        nameEn: '费用名称(英文)',
        feeNameByRateType: {
          directDrag: '拖车费',
          branchLine: '配送费',
          seaRail: '铁路拖运费'
        },
        billingUnit: '计费单位',
        currency: '币种',
        unitRate: '单价',
        min: '最低收费',
        max: '最高收费',
        remarks: '备注',
        operations: '操作'
      },

      surcharge: {
        title: '附加费明细',
        addContainerColumn: '添加箱型列',
        feeName: '费用名称',
        feeType: '费用类型',
        unit: '单位',
        currency: '币种',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        remarks: '费用备注',
        operations: '操作'
      },

      originLabel: '起运地',
      destinationLabel: '目的港'
    },

    // 尾程
    lastmile: {
      createTitle: '新建尾程运价',
      editTitle: '编辑尾程运价',
      viewTitle: '尾程运价详情',
      copyTitle: '复制尾程运价',

      columns: {
        priceNo: '运价编码',
        rateNo: '运价编码',
        source: '运价来源',
        supplier: '供应商',
        rateType: '运价类型',
        unloadingNodeType: '目的节点类型',
        unloadingNode: '目的节点',
        unloadingFacility: '目的码头/货站',
        pod: '目的港',
        podAirport: '目的机场',
        wharfId: '目的码头',
        destinationPort: '目的港',
        destinationTerminal: '目的码头',
        destinationStation: '目的站',
        destinationAirport: '目的机场',
        unloadingCountry: '目的国家',
        airportTerminal: '目的机场货站',
        deliveryAddressType: '地址类型',
        country: '国家',
        state: '州',
        city: '市',
        district: '区域',
        postalCode: '邮编',
        address: '详细地址',
        warehouseCode: '仓库',
        destination: '目的地',
        deliveryMode: '派送方式',
        currency: '币种',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        createdBy: '创建人',
        dateCreated: '创建时间',
        modifiedBy: '修改人',
        dateModified: '修改时间'
      },

      enums: {
        addressType: {
          thirdParty: '第三方地址',
          amazon: '仓库',
          warehouse: '仓库'
        },
        cargoType: {
          general: '普货',
          magnetic: '带磁',
          battery: '带电',
          magneticBattery: '带磁带电'
        },
        rateType: {
          directDrag: '直拖',
          branchLine: '支线',
          seaRail: '海铁'
        }
      },

      sections: {
        basicInfo: '基础信息',
        addressInfo: '地址信息',
        destinationInfo: '目的地信息',
        deliveryAddress: '配送地址',
        portInfo: '目的港/机场信息',
        feeInfo: '费用明细',
        surchargeDetail: '附加费明细'
      },

      placeholders: {
        rateType: '请选择运价类型',
        deliveryAddressType: '请选择地址类型',
        postalCode: '请输入邮编',
        address: '请输入详细地址',
        warehouseCode: '请选择仓库（可多选）',
        pod: '请选择目的港',
        podAirport: '请选择目的机场',
        wharfId: '请选择目的码头',
        destinationPort: '请选择目的港',
        destinationTerminal: '请选择目的码头',
        destinationAirport: '请选择目的机场',
        airportTerminal: '请输入目的机场货站'
      },

      validation: {
        supplierId: '请选择供应商',
        cargoType: '请选择货物类型',
        rateType: '请选择运价类型',
        deliveryAddressType: '请选择地址类型',
        validPeriod: '请选择价格有效期',
        pod: '请选择目的港',
        country: '请选择国家',
        state: '请选择州',
        city: '请选择市',
        address: '请输入详细地址',
        warehouseCode: '请至少选择一个仓库',
        podOrPodAirport: '目的港和目的机场至少填写一个',
        destinationPort: '请选择目的港',
        destinationStation: '请选择目的站',
        destinationAirport: '请选择目的机场',
        specifiedMatchRequired: '海港非箱型拼箱费用必须填写指定匹配运价'
      },

      feeSection: {
        title: '运费',
        addRow: '添加费用行',
        feeName: '费用名称',
        nameCn: '费用名称(中文)',
        nameEn: '费用名称(英文)',
        feeNameByRateType: {
          directDrag: '拖车费',
          branchLine: '配送费',
          seaRail: '铁路拖运费'
        },
        billingUnit: '计费单位',
        currency: '币种',
        unitRate: '单价',
        min: '最低收费',
        max: '最高收费',
        remarks: '备注',
        operations: '操作'
      },

      surcharge: {
        title: '附加费明细',
        addContainerColumn: '添加箱型列',
        feeName: '费用名称',
        feeType: '费用类型',
        unit: '单位',
        currency: '币种',
        unitRate: '单价',
        min: '最小',
        max: '最大',
        remarks: '费用备注',
        operations: '操作'
      },

      originLabel: '目的港',
      destinationLabel: '目的地'
    }
  }
}
